import { createAction, props } from '@ngrx/store';
import { ITimeCardSubmit } from '../ITimeCardSubmit';
import { Update } from '@ngrx/entity';

export const putTimeCardSubmit = createAction(
  '[TimeCardSubmit/API] Update TimeCardSubmit',
  props<{ timeCardSubmit: Array<ITimeCardSubmit> }>()
);

export const loadTimeCardSubmits = createAction(
  '[TimeCardSubmit] Load TimeCardSubmits'
);

export const updateTimeCardSubmit = createAction(
  '[TimeCardSubmit/API] Update TimeCardSubmit',
  props<{ timeCardSubmit: Update<ITimeCardSubmit> }>()
);

export const updateTimeCardSubmits = createAction(
  '[TimeCardSubmit/API] Update TimeCardSubmits',
  props<{ timeCardSubmits: Update<ITimeCardSubmit>[] }>()
);




